module.exports = __webpack_public_path__ + "img/more.2f2dc429.png";